export default __webpack_public_path__ + "media/images/backgrounds/brown-vegetables-bg-c1369c7765d2e70363bdd7000593ebfc.svg";